import {
    AdminOption,
    SettingOption,
    FlowOption
} from "../Types";
import * as React from "react";
import { SelectControl } from "../../FormControls/SelectControl";
const Switch = require("react-switch");

export const AdminOptionRow = (opts: AdminOption, index: number): JSX.Element => {
    const renderSwitch = (options: FlowOption) => (
        <Switch
            onChange={(val) => options.changeFunction(val)}
            checked={options.selected}
            height={40}
            width={80}
            disabled={options.disabled}
            aria-labelledby="neat-label"
            offColor="#ef6e64"
            uncheckedIcon={false}
            checkedIcon={false}
            handleDiameter={30}
            onColor="#4bca81"
        />
    );
    const renderSelectionBar = (options: SettingOption) => (
        <SelectControl
            isInvalid={options.isInvalid}
            value={options.value}
            options={options.options}
            onChange={(value: string) => options.changeFunction(parseInt(value, 10))}
        />

    )

    return (
        <tr key={"adminOptions" + index}>
            <td className="col-sm-10 description-column">
                <h2 className="option-title">
                    {opts.title}
                </h2>
                <p className="description-detail">
                    {opts.text}
                </p>
            </td>
            <td className="col-sm-2 switch-column">
                {
                    opts.type === "FlowOption" ?
                        renderSwitch(opts as FlowOption) :
                        renderSelectionBar(opts as SettingOption)
                }
            </td>
        </tr>
    );
};




// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/Tabs/AdminOptionRow.tsx